import React from 'react';

const FullLoading = () => {
    return (
        <div className='absolute z-50 top-0 left-0 right-0 bottom-0 bg-white min-w-screen min-h-screen flex flex-col justify-between items-center p-3'>
            <div className='mt-3 mb-5'>
                <img src={'/assets/admin/header-icon.svg'} className='object-contain min-h-[45px]' />
            </div>
            <div className='m-auto flex flex-col items-center'>
                <img src={'/assets/admin/hotel-icon.svg'} className='object-contain min-w-[60px] mb-5' />
                <p className='text-center text-4xl text-[#101010]'>Re<span className='font-bold'>directing...</span></p>
                <p className='text-center text-[#101010] my-4'>Your time our priority!</p>
            </div>
            <div className='min-w-[100%] flex flex-row justify-between items-center'>
                <div className='flex items-center'>
                    <div className='cursor-pointer hover:opacity-80'>Terms</div>
                    <span className='px-1 text-black'>•</span>
                    <div className='cursor-pointer hover:opacity-80'>Privacy Policy</div>
                </div>
                <div>
                    <p>&copy; All rights reserved.</p>
                </div>
            </div>
        </div>
    )

}
export default FullLoading;